import { isProd } from './isProd'

// category - address, hash
export const generateXdcScanUrl = (category, value) => {
  const baseUrl = isProd ? 'https://xdcscan.com' : 'https://testnet.xdcscan.com'

  if (category === 'address') {
    return `${baseUrl}/address/${value}`
  }

  return `${baseUrl}/tx/${value}`
}
